const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');

// @ commons
const { formatText } = require('core/i18n').i18n;

// @ components
const MortgageRequestCover = require('components/mortgageRequest/mortgageRequestCover/mortgageRequestCover');
const MortgageRequestHeader = require('components/mortgageRequest/mortgageRequestHeader/mortgageRequestHeader');
const { MortgageRequestEstatesSuccessful } = require('components/mortgageRequest/mortgageRequestEstates/mortgageRequestEstatesSuccessful/mortgageRequestEstatesSuccessful');

const MortgageRequestEstatesSuccessfulResultView = props => {
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText('mortgageRequestEstatesSuccessfulResult-title'),
            url: ''
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        < div className="mortgage-request-estates-result-successful-view" >
            <MortgageRequestCover>
                <MortgageRequestHeader
                    breadcrumbConfig={mappingBreadcrumb}
                    titleKey="mortgageRequestEstatesSuccessfulResult-title"
                />
            </MortgageRequestCover>
            <div className="mortgage-request-estates-result-successful-view__body">
                <MortgageRequestEstatesSuccessful />
            </div>
        </div >
    );
}

MortgageRequestEstatesSuccessfulResultView.propTypes = {
    immGlobalPosition: PropTypes.object.isRequired,
}

module.exports.MortgageRequestEstatesSuccessfulResultView = connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestEstatesSuccessfulResultView);
